<template>
    <b-button
        v-b-tooltip.hover
        variant="transparent"
        class="video-invert-toggle"
        :pressed="invert"
        :title="$translate('invert')"
        @click="invertVideoColours"
    >
        <i class="fa fa-adjust" :class="{ inverted: invert }"></i>
    </b-button>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'VideoInvertToggle',
    computed: {
        ...mapState({
            focusedWell: state => state.timelapse.focusedWell
        }),
        invert() {
            return this.focusedWell.invert
        }
    },
    methods: {
        invertVideoColours() {
            this.$log.videoEvent('invert_colors_changed', !this.invert)

            this.$store.commit('timelapse/wellInvert', !this.invert)
        }
    }
}
</script>

<style lang="scss" scoped>
.video-invert-toggle {
    .fa-adjust {
        font-size: 14pt;

        &.inverted {
            color: $blue;
        }
    }
}
</style>
